'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';
import UIColorSquatch from 'UIComponents/color/UIColorSquatch';
import UIColorSquatchGrid from 'UIComponents/color/UIColorSquatchGrid';
import { jsx as _jsx } from "react/jsx-runtime";
class SquatchGrid extends Component {
  colorMatches(col1, col2) {
    // color in hex string
    return col1 && col2 && col1.toLowerCase() === col2.toLowerCase();
  }
  getValues(data) {
    const {
      defaultAlpha,
      defaultColor
    } = this.props;
    // data is hex string
    if (/^#[0-9a-fA-F]{3,6}$/.test(data)) {
      return {
        color: data,
        alpha: defaultAlpha
      };
    }
    if (data.color && data.alpha) {
      const color = data.color;
      const alpha = isNaN(data.alpha) ? defaultAlpha : data.alpha;
      return {
        color,
        alpha
      };
    }
    setTimeout(() => {
      throw new Error(`Unable to parse color from ${data}`);
    }, 0);
    return {
      alpha: defaultAlpha,
      color: defaultColor
    };
  }
  render() {
    const {
      className,
      currentColor,
      gapSize,
      grid,
      onClick,
      squatchSize,
      showMatchedSquatch
    } = this.props;
    let _alreadyMatchedColor = !showMatchedSquatch;
    return /*#__PURE__*/_jsx(UIColorSquatchGrid, {
      "data-test-id": "colorpicker-squatch-grid",
      className: classNames('private-react-colorpicker-popover--color-grid', className),
      gapSize: gapSize,
      children: grid.map((data, i) => {
        const {
          color,
          alpha
        } = this.getValues(data);
        const colorMatch = !_alreadyMatchedColor && this.colorMatches(color, currentColor);
        _alreadyMatchedColor = _alreadyMatchedColor || colorMatch;
        return /*#__PURE__*/_jsx(UIColorSquatch, {
          "data-test-id": "colorpicker-squatch",
          color: color,
          onClick: () => {
            onClick({
              alpha,
              color
            });
          },
          opacity: alpha,
          selected: colorMatch,
          size: squatchSize
        }, i);
      })
    });
  }
}
SquatchGrid.defaultProps = {
  defaultAlpha: 100,
  defaultColor: '#FFFFFF',
  gapSize: 5,
  squatchSize: 25,
  showMatchedSquatch: true
};
SquatchGrid.propTypes = {
  className: PropTypes.string,
  currentColor: PropTypes.string.isRequired,
  defaultAlpha: PropTypes.number,
  defaultColor: PropTypes.string,
  gapSize: PropTypes.number,
  grid: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    color: PropTypes.string,
    alpha: PropTypes.string
  })])).isRequired,
  onClick: PropTypes.func.isRequired,
  squatchSize: PropTypes.number,
  showMatchedSquatch: PropTypes.bool
};
export default SquatchGrid;